// Centralised rank system used across HomeScreen, LeaderboardScreen, ProfileScreen
export const RANKS = [
    { name: "Bronze", color: "#b45309", min: 0, max: 499 },
    { name: "Silver", color: "#94a3b8", min: 500, max: 999 },
    { name: "Gold", color: "#f59e0b", min: 1000, max: 1999 },
    { name: "Platinum", color: "#a78bfa", min: 2000, max: 3999 },
    { name: "Diamond", color: "#22d3ee", min: 4000, max: null },
];
export function getRank(rp) {
    return RANKS.slice().reverse().find(r => rp >= r.min) ?? RANKS[0];
}
export function getRankProgress(rp) {
    const rank = getRank(rp);
    if (!rank.max)
        return 100;
    return Math.round(((rp - rank.min) / (rank.max - rank.min + 1)) * 100);
}
export function getNextRank(rp) {
    const idx = RANKS.findIndex(r => getRank(rp).name === r.name);
    return RANKS[idx + 1] ?? null;
}
export function getRankColor(rp) {
    return getRank(rp).color;
}
// ELO rating tier label/color (different scale from rank points)
export function getRatingLabel(rating) {
    if (rating >= 1200)
        return "ELITE";
    if (rating >= 900)
        return "PRO";
    if (rating >= 700)
        return "MID";
    return "ROOKIE";
}
export function getRatingColor(rating) {
    if (rating >= 1200)
        return "#f59e0b";
    if (rating >= 900)
        return "#ef4444";
    if (rating >= 700)
        return "#8b5cf6";
    return "#64748b";
}
